import { useState } from 'react'

/**
 * Einmal anzeigbarer Einmal-Code mit Kopieren-Button + Hinweis. Genutzt für Onboarding-, Reset- und
 * Chef-Aktivierungscodes — der Server gibt den Klartext bewusst NUR EINMAL aus (danach liegt nur der Hash in der DB).
 */
export function CodeReveal({ code, hint }: { code: string; hint: string }) {
  const [copied, setCopied] = useState(false)
  function copy() {
    void navigator.clipboard?.writeText(code).then(
      () => setCopied(true),
      () => setCopied(false),
    )
  }
  return (
    <div className="wf-card wf-codereveal">
      <code className="wf-code">{code}</code>
      <button type="button" className="wf-btn wf-btn--sm" onClick={copy}>
        {copied ? 'Kopiert ✓' : 'Kopieren'}
      </button>
      <p className="hint">{hint} Dieser Code wird nur EINMAL angezeigt — gib ihn jetzt weiter.</p>
    </div>
  )
}
